import React from 'react';

const ProductOverview = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Product Overview</h1>
          <div className="max-w-3xl mx-auto">
            <p className="text-lg text-gray-700 mb-8">
              olaid is your personal first-aid companion, designed to help you manage and access critical medical information when you need it most.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Access</h3>
                <p className="text-gray-600">
                  Instant access to your medical information, emergency contacts, and first-aid instructions.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Emergency Ready</h3>
                <p className="text-gray-600">
                  Be prepared for medical emergencies with step-by-step guidance and quick access to vital information.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductOverview; 